import type { ReactNode } from 'react';

import { Fade, Popper } from '@mui/material';
import type { PopperPlacementType } from '@mui/material';

interface HoverCardProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onKeepOpen: () => void;
  onExited?: () => void;
  children: ReactNode;
  placement?: PopperPlacementType;
}

export const HoverCard = ({
  anchorEl,
  onClose,
  onKeepOpen,
  onExited,
  children,
  placement = 'right',
}: HoverCardProps) => (
  <Popper
    open={!!anchorEl}
    anchorEl={anchorEl}
    placement={placement}
    modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
    style={{ zIndex: 1300 }}
    transition
  >
    {({ TransitionProps }) => (
      <Fade
        {...TransitionProps}
        timeout={200}
        onExited={() => {
          TransitionProps?.onExited?.();
          onExited?.();
        }}
      >
        <div onMouseEnter={onKeepOpen} onMouseLeave={onClose}>
          {children}
        </div>
      </Fade>
    )}
  </Popper>
);
